// src/routes/index.tsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import { Admin } from "./config/Admin";
import { SuperAdmin } from "./config/SuperAdmin";
import { LoadingManager } from "./config/LoadingManager";
import { Public } from "./config/Public";
import ScrollToTop from "./utils/ScrollToTop";

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-light dark:bg-dark text-dark dark:text-light transition-colors">
            <div className="flex flex-col items-center gap-4">
              <svg
                className="animate-spin h-10 w-10 text-primary"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
              <p className="text-sm font-medium">Loading, please wait...</p>
            </div>
          </div>
        }
      >
        <Routes>
          {/* 🔓 Public Routes */}
          {Public.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          {/* 🔐 Admin Routes */}
          {Admin.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          {/* 🔐 SuperAdmin Routes */}
          {SuperAdmin.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          {/* 🔐 Loading Manager Routes */}
          {LoadingManager.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

         
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
